import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: localStorage.getItem("authTokenComptable") || null,
    email: localStorage.getItem("emailComptable") || null,
    isAuthenticated: !!localStorage.getItem("authTokenComptable"),
};

const authComptableSlice = createSlice({
    name: "authComptable",
    initialState,
    reducers: {
        setAuthComptable: (state, action) => {
            const { token, email } = action.payload;

            if (token) {
                state.token = token;
                localStorage.setItem("authTokenComptable", token);
            }

            if (email) {
                state.email = email;
                localStorage.setItem("emailComptable", email);
            }

            state.isAuthenticated = !!state.token;
        },

        clearAuthComptable: (state) => {
            state.token = null;
            state.email = null;
            state.isAuthenticated = false;

            localStorage.removeItem("authTokenComptable");
            localStorage.removeItem("emailComptable");
        },
    },
});

// Selecteurs
export const selectAuthComptable = (state) => state.authComptable;

export const { setAuthComptable, clearAuthComptable } = authComptableSlice.actions;
export default authComptableSlice.reducer;
